import { Injectable } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { ApiService } from "../shared/utilities/api.service";
import { Comment, CommentListConfig, Discussion } from "../../models";
import { CommentListResult } from "../../interfaces";

@Injectable()
export class CommentService {
  constructor(private apiService: ApiService) {}

  public saveOne(
    discussion: Discussion,
    comment: Comment
  ): Observable<Comment> {
    // POST /api/discussions/:community/:discussion/comments
    const communityName = discussion.community.name;
    const discussionSlug = discussion.slug;
    const commentId = comment.id;
    const putURL = `/discussions/${communityName}/${discussionSlug}/comments/${commentId}`;
    const postURL = `/discussions/${communityName}/${discussionSlug}/comments`;

    // If we're updating an existing comment
    if (commentId) {
      return this.apiService
        .put(putURL, { comment: comment })
        .pipe(map((data) => data.comment));
    }
    // Otherwise, create a new comment
    else {
      return this.apiService
        .post(postURL, { comment: comment })
        .pipe(map((data) => data.comment));
    }
  }

  public deleteOne(discussion: Discussion, comment: Comment) {
    // DELETE /api/discussions/:community/:discussion/comments/:comment
    const communityName = discussion.community.name;
    const discussionSlug = discussion.slug;
    const commentId = comment.id;
    const deleteURL = `/discussions/${communityName}/${discussionSlug}/comments/${commentId}`;

    return this.apiService.delete(deleteURL);
  }

  public findMany(
    discussion: Discussion,
    config: CommentListConfig
  ): Observable<CommentListResult> {
    let params = {};

    Object.keys(config).forEach((key) => {
      params[key] = config[key];
    });

    // GET /api/discussions/:community/:discussion/comments
    const communityName = discussion.community.name;
    const discussionSlug = discussion.slug;
    const url = `/discussions/${communityName}/${discussionSlug}/comments`;

    var finalParams = new HttpParams({ fromObject: params });
    return this.apiService.get(url, finalParams).pipe(map((data) => data));
  }
}
